exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdsSellerPage__container___27AoU {\n  max-width: 1360px;\n  margin: 0 auto;\n  padding-bottom: 80px; }\n\n.AdsSellerPage__breadcrumb___2283h {\n  margin-top: 15px;\n  margin-bottom: 24px;\n  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.05); }\n\n.AdsSellerPage__sellerCardWrapper___3881u {\n  margin-bottom: 24px; }\n\n.AdsSellerPage__searchSectionContainer___2ZW3i {\n  overflow: hidden;\n  display: flex; }\n  @media (max-width: 768px) {\n    .AdsSellerPage__searchSectionContainer___2ZW3i {\n      flex-direction: column; } }\n\n.AdsSellerPage__contactSection___22RNo {\n  margin-left: 345px;\n  margin-bottom: 50px; }\n  @media (max-width: 768px) {\n    .AdsSellerPage__contactSection___22RNo {\n      margin-left: 0; } }\n\n@media (max-width: 768px) {\n  .AdsSellerPage__sellerCardWrapper___3881u {\n    padding: 0 16px; } }\n", ""]);

// exports
exports.locals = {
	"container": "AdsSellerPage__container___27AoU",
	"breadcrumb": "AdsSellerPage__breadcrumb___2283h",
	"sellerCardWrapper": "AdsSellerPage__sellerCardWrapper___3881u",
	"searchSectionContainer": "AdsSellerPage__searchSectionContainer___2ZW3i",
	"contactSection": "AdsSellerPage__contactSection___22RNo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdsSellerPage/styles/AdsSellerPage.scss
// module id = 4917
// module chunks = 6